import React from "react";
import { connect } from "react-redux";
import withSizes from "react-sizes";
import { Redirect } from "react-router-dom";

import { Message } from "../../Message";
import { GroupingsService, DashboardService } from "../../../services";
import { NADLocationJumper } from "./needs_attention_components";
import TotalsAndHelpArea from "./totals_and_help_area";
import OtherLocationsArea from "./other_locations_area";
import CriticalLocationsArea from "./critical_locations_area";
import { EntityDetailModal } from "../../Entity";

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 830,
});

@connect((state) => {
  return {
    currentGrouping: state.currentGrouping.currentGrouping,
    me: state.user.me,
  };
})
class NeedsAttentionDashboardView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      loadingLocations: true,
      locationFilterValue: null,
      showEntityDetailModal: false,
      entitySerialNumber: null,
    };
  }

  filterAndSortGroupings(groupings) {
    return groupings
      .filter(({ deviceGroup }) => deviceGroup.children.length == 0)
      .sort((groupingA, groupingB) => {
        if (groupingA.name < groupingB.name) {
          return -1;
        }
        if (groupingA.name > groupingB.name) {
          return 1;
        }
        return 0;
      })
      .map((grouping) => {
        return {
          value: grouping.id,
          label: grouping.name,
          grouping: grouping,
        };
      });
  }

  componentDidMount() {
    if (this.props.me.availableGroupings.length > 0) {
      this.setState({ loadingLocations: true });
      GroupingsService.listAll([])
        .then((response) => {
          this.setState({
            availableLocations: this.filterAndSortGroupings(response.groupings),
            loadingLocations: false,
          });
        })
        .catch((error) => {
          console.error(error);
          this.setState({
            hasError: true,
            localErrorMessage: error.message,
            loadingLocations: false,
          });
          this.state.localErrorHandler(error.message);
        });
    } else {
      this.setState({ availableLocations: [] });
    }

    DashboardService.getReportOrDashboardDataByToken("locations_offline_count")
    .then((response) => {
      if (response.reportResult) {
        this.setState({
          offlineLocations: response.reportResult && response.reportResult
            .filter((countData) => countData["device_count"] == countData["offline_count"])
        })
      } else {
        this.setState({ offlineLocations: [] });
      }
  })       
  .catch((error) => {
    console.error(error);
    this.setState({
      hasError: true,
      localErrorMessage: error.message,
    });
    this.state.localErrorHandler(error.message);
  })
}

  handleHistoryUpdate(params) {
    this.props.history.push(params);
  }

  renderMessages() {
    return this.state.localErrorMessage || this.state.localSuccessMessage ? (
      <Message
        messages={{ state: { successMessage: this.state.localSuccessMessage } }}
        errorMessage={this.state.localErrorMessage}
        messageDismissCallback={this.messageDismissCallback.bind(this)}
      />
    ) : null;
  }

  messageDismissCallback() {
    localStorage.removeItem("global_success_message");
    this.setState({ localErrorMessage: null, localSuccessMessage: null });
  }

  locationClicked(selection) {
    this.setState({ gotoLocationGroupingId: selection.grouping.id });
  }

  render() {
    if (this.state.gotoLocationGroupingId) {
      return (
        <Redirect push exact to={{
            pathname: `/monitoring/locations/${this.state.gotoLocationGroupingId}/assets`,
            state: { fromPath: "/monitoring/dashboard" }
          }}
        />
      );
    }

    if (this.state.localErrorMessage) {
      return <div style={{ paddingTop: 30 }}>{this.renderMessages()}</div>;
    }

    if (this.state.loadingLocations) {
      return <div className="loader">Loading...</div>;
    } else {
      return (
        <div className="animated fadeIn needs-attention-dash">
          {this.renderMessages()}

          <NADLocationJumper
            isLoading={this.state.loadingLocations}
            availableLocations={this.state.availableLocations}
            locationClicked={this.locationClicked.bind(this)}
          />

          <TotalsAndHelpArea
            availableLocations={this.state.availableLocations}
            onError={(error) =>
              this.setState({
                hasError: true,
                localErrorMessage: error.message,
              })
            }
          />

          <CriticalLocationsArea
            availableLocations={this.state.availableLocations}
            showEntityDetail={(entitySerialNumber, areaName) =>
              this.setState({
                entitySerialNumber: entitySerialNumber,
                detailArea: areaName,
                showEntityDetailModal: true,
              })
            }
            locationClicked={this.locationClicked.bind(this)}
            onError={(error) =>
              this.setState({
                hasError: true,
                localErrorMessage: error.message,
              })
            }
          />

          <OtherLocationsArea
            availableLocations={this.state.availableLocations}
            offlineLocations={this.state.offlineLocations}
            locationClicked={this.locationClicked.bind(this)}
            onError={(error) =>
              this.setState({
                hasError: true,
                localErrorMessage: error.message,
              })
            }
          />

          <EntityDetailModal
            isMobile={this.props.isMobile}
            entitySerialNumber={this.state.entitySerialNumber}
            show={this.state.showEntityDetailModal}
            onHide={() =>
              this.setState({
                entitySerialNumber: null,
                detailArea: null,
                showEntityDetailModal: false,
              })
            }
            onError={(errorMessage) =>
              this.setState({ errorMessage: errorMessage })
            }
          />
        </div>
      );
    }
  }
}

export default withSizes(mapSizesToProps)(NeedsAttentionDashboardView);
